"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ms = _interopRequireDefault(require("ms"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _gbp = _interopRequireDefault(require("gbp"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _paymentEntries = _interopRequireDefault(require("./payment-entries"));
var _paymentsHelp = _interopRequireDefault(require("./payments-help"));
var _refunds = _interopRequireDefault(require("./refunds"));
var _formatDateTime = _interopRequireDefault(require("../../../../../utils/formatDateTime"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// the styled components are purely to improve the layout of the printed version of the start list
// Tr shrinks all the table rows. Tbody should stop breaks within each group but does not always do so
// successfully (depends on browser).
const Tr = _styledComponents.default.tr`
  @media print {
    font-size: 0.6em;
    line-height: 0.6em;
  }
`;
const H2 = _styledComponents.default.h2`
  @media print {
    font-size: 1em;
    line-height: 1em;
    margin-bottom: 0em;
    margin-top: 0.1em;
  }
  margin-top: 0.5em;
`;
var _ref = /*#__PURE__*/_react.default.createElement(H2, null, "On-Line Payments and Refunds");
var _ref2 = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_paymentsHelp.default, null));
var _ref3 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement(Tr, null, /*#__PURE__*/_react.default.createElement("th", {
  className: "hidden-print"
}), /*#__PURE__*/_react.default.createElement("th", {
  className: "hidden-print"
}), /*#__PURE__*/_react.default.createElement("th", null, "Date"), /*#__PURE__*/_react.default.createElement("th", {
  className: "hidden-print"
}, "Contact Email"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Paid To Club"), /*#__PURE__*/_react.default.createElement("th", null)));
var _ref4 = /*#__PURE__*/_react.default.createElement("td", null);
var _ref5 = /*#__PURE__*/_react.default.createElement("td", null);
var _ref6 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right",
  colSpan: 4
}, "BALANCE");
class Payments extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      showEntries: [],
      showRefunds: []
    });
    _defineProperty(this, "_msSince", thisdatetime => {
      let msSince = 0;
      if (thisdatetime) {
        msSince = new Date(thisdatetime).getTime();
        msSince = Math.max(Date.now() - msSince, 0);
      }
      return msSince;
    });
    _defineProperty(this, "_toggleShowEntries", paymentID => {
      this.setState({
        showEntries: {
          ...this.state.showEntries,
          [paymentID]: !this.state.showEntries[paymentID]
        }
      });
    });
    _defineProperty(this, "_toggleShowRefunds", paymentID => {
      this.setState({
        showRefunds: {
          ...this.state.showRefunds,
          [paymentID]: !this.state.showRefunds[paymentID]
        }
      });
    });
    _defineProperty(this, "_getStatusField", payment => {
      const statusClass = payment.paymentStatusRef === 'PAID' ? 'text-xs-right text-success' : payment.paymentStatusRef === 'ERR' ? 'text-xs-right text-danger' : 'text-xs-right';
      let statusText = payment.paymentStatusDescription;
      if (payment.paymentStatusRef === 'ERR') {
        statusText += (payment.errorNotifiedDate ? '- user notified ' : '') + (payment.errorNotifiedDate ? (0, _ms.default)(this._msSince(payment.errorNotifiedDate), {
          long: true
        }) : '') + (payment.errorNotifiedDate ? ' ago.' : '');
      }
      return /*#__PURE__*/_react.default.createElement("td", {
        className: statusClass
      }, statusText);
    });
  }
  render() {
    const competition = this.props.competition;

    // Calculate total payments and refunds
    let totalExpectedForClub = 0;
    let totalRefundedByClub = 0;
    let numberOfRefunds = 0;
    const numberOfPayments = Object.keys(competition.payments).length;
    for (const payment of competition.payments) {
      totalExpectedForClub += payment.expectedForClub;
      numberOfRefunds += Object.keys(payment.refunds).length;
      for (const refund of payment.refunds) {
        totalRefundedByClub += refund.refundedByClub;
      }
    }
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, _ref2, !this.props.competition.isAdministratedByUser ? null : /*#__PURE__*/_react.default.createElement(_table.default, null, _ref3, /*#__PURE__*/_react.default.createElement("tbody", null, competition.payments.map(payment => [/*#__PURE__*/_react.default.createElement(Tr, {
      key: payment.id,
      className: this._msSince(payment.errorNotifiedDate) > (0, _ms.default)('48h') && payment.paymentStatusRef === 'ERR' ? 'table-danger' : ''
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "hidden-print"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "sm",
      onClick: this._toggleShowEntries.bind(this, payment.id)
    }, this.state.showEntries[payment.id] ? 'Hide Entries' : 'Show Entries')), /*#__PURE__*/_react.default.createElement("td", {
      className: "hidden-print"
    }, !payment.refunds.length ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "sm",
      onClick: this._toggleShowRefunds.bind(this, payment.id)
    }, this.state.showRefunds[payment.id] ? 'Hide Refunds' : 'Show Refunds')), /*#__PURE__*/_react.default.createElement("td", null, (0, _formatDateTime.default)(payment.createdDate)), /*#__PURE__*/_react.default.createElement("td", {
      className: "hidden-print"
    }, payment.paidByUserEmail), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(payment.expectedForClub)), this._getStatusField(payment)), !this.state.showEntries[payment.id] ? null : /*#__PURE__*/_react.default.createElement(Tr, {
      key: 'entries-for-' + payment.id
    }, _ref4, /*#__PURE__*/_react.default.createElement("td", {
      colSpan: 5
    }, /*#__PURE__*/_react.default.createElement(_paymentEntries.default, {
      showEntries: this.state.showEntries[payment.id],
      entries: payment.entries,
      displayDateTime: _formatDateTime.default
    }))), !this.state.showRefunds[payment.id] ? null : /*#__PURE__*/_react.default.createElement(Tr, {
      key: 'refunds-for-' + payment.id
    }, _ref5, /*#__PURE__*/_react.default.createElement("td", {
      colSpan: 5
    }, /*#__PURE__*/_react.default.createElement(_refunds.default, {
      refunds: payment.refunds,
      displayDateTime: _formatDateTime.default
    })))])), /*#__PURE__*/_react.default.createElement("tfoot", {
      className: "hidden-print"
    }, /*#__PURE__*/_react.default.createElement(Tr, null, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right",
      colSpan: 4
    }, numberOfPayments + ' Payments Totalling'), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totalExpectedForClub))), !numberOfRefunds ? null : [/*#__PURE__*/_react.default.createElement(Tr, {
      key: "total-refunds"
    }, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right",
      colSpan: 4
    }, numberOfRefunds + ' Refunds Totalling'), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totalRefundedByClub))), /*#__PURE__*/_react.default.createElement(Tr, {
      key: "balance"
    }, _ref6, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totalExpectedForClub - totalRefundedByClub)))])));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref7 = {
  isAdministratedByUser: true,
  payments: {
    id: true,
    paidByUserEmail: true,
    expectedForClub: true,
    paymentStatusRef: true,
    paymentStatusDescription: true,
    errorNotifiedDate: true,
    createdDate: true,
    refunds: _mergeBqlQueries({
      id: true,
      refundedByClub: true
    }, _refunds.default.partialQueries.Refunds),
    entries: _mergeBqlQueries({
      id: true
    }, _paymentEntries.default.partialQueries.Entries)
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(Payments, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref7
}));